import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { PostList } from "./PostList";
import { PostEditor } from "./PostEditor";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BlogAdmin = ({ token, onUnauthorized }) => {
  const [posts, setPosts] = useState([]);
  const [editing, setEditing] = useState(null); // null = lista, "new" = nuovo, oggetto = modifica
  const [saving, setSaving] = useState(false);
  const auth = { headers: { Authorization: `Bearer ${token}` } };

  const load = () => axios.get(`${API}/admin/posts`, auth).then((r) => setPosts(r.data)).catch((e) => e.response?.status === 401 && onUnauthorized());
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fail = (e, fallback) => {
    if (e.response?.status === 401) return onUnauthorized();
    const d = e.response?.data?.detail;
    toast.error(typeof d === "string" ? d : fallback);
  };

  const save = async (post) => {
    setSaving(true);
    try {
      if (editing === "new") await axios.post(`${API}/admin/posts`, post, auth);
      else await axios.put(`${API}/admin/posts/${editing.slug}`, post, auth);
      toast.success(post.published ? "Articolo salvato e pubblicato" : "Bozza salvata");
      setEditing(null);
      load();
    } catch (e) {
      fail(e, "Errore nel salvataggio");
    } finally {
      setSaving(false);
    }
  };

  const togglePublish = async (p) => {
    try {
      await axios.put(`${API}/admin/posts/${p.slug}`, { ...p, published: !p.published }, auth);
      toast.success(p.published ? "Articolo nascosto" : "Articolo pubblicato");
      load();
    } catch (e) {
      fail(e, "Operazione non riuscita");
    }
  };

  const remove = async (p) => {
    if (!window.confirm(`Eliminare definitivamente "${p.title.it || p.slug}"?`)) return;
    try {
      await axios.delete(`${API}/admin/posts/${p.slug}`, auth);
      toast.success("Articolo eliminato");
      load();
    } catch (e) {
      fail(e, "Eliminazione non riuscita");
    }
  };

  if (editing) {
    return <PostEditor key={editing === "new" ? "new" : editing.slug} initial={editing === "new" ? null : editing} onSave={save} onCancel={() => setEditing(null)} saving={saving} token={token} />;
  }
  return <PostList posts={posts} onNew={() => setEditing("new")} onEdit={setEditing} onDelete={remove} onTogglePublish={togglePublish} />;
};
